import { request } from "#/utils/request";

interface IVendasAssinarContrato {
  codigoComissionado: string;
  idDocumento: number;
  conta: string;
  cooperativa: string;
  documento: string;
}

export interface IVendasAssinarContratoData {
  data: AssinarContratoData;
  errors: Errors;
}

interface AssinarContratoData {
  contract: string;
}

interface Errors {
  message: string;
  code: number;
}

export const vendasAssinarContrato = async ({
  codigoComissionado,
  idDocumento,
  conta,
  cooperativa,
  documento,
}: IVendasAssinarContrato) =>
  (
    await request.post<IVendasAssinarContratoData>(
      `/vendas/assinar-contrato?codigoComissionado=${codigoComissionado}&idDocumento=${idDocumento}&conta=${conta}&cooperativa=${cooperativa}&documento=${documento}`,
      {}
    )
  ).data;
